module.exports = __webpack_public_path__ + "static/media/caret-down.33c56e8f.svg";